import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }

import CheckConnection from "../CheckConnection.vue";
import HelpLink from "../HelpLink.vue";
import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  ISwitchboardTokenCreds,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import { HELP_URL_BY_PLATFORM } from "../../../../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'SwitchboardToken',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const isLoading = ref<boolean>(false);

const isConnectionValid = ref<boolean | null>(
  props.modelValue && props.modelValue.type === EAuthTypes.TOKEN ? true : null
);

const isDisabled = computed<boolean>(() => {
  return !!props.disable || isLoading.value;
});

const emit =
  __emit;

const EMPTY_MODEL: ISwitchboardTokenCreds = {
  type: EAuthTypes.TOKEN,
  apiId: "",
  apiKey: "",
};

const model = computed<ISwitchboardTokenCreds>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: ISwitchboardTokenCreds) {
    emit("update:modelValue", value);
  },
});

const apiIdModel = computed<string>({
  get() {
    return props.modelValue?.apiId ?? EMPTY_MODEL.apiId;
  },
  set(value: string) {
    model.value = { ...model.value, apiId: value };
  },
});

const apiKeyModel = computed<string>({
  get() {
    return props.modelValue?.apiKey ?? EMPTY_MODEL.apiKey;
  },
  set(value: string) {
    model.value = { ...model.value, apiKey: value };
  },
});

const currentMethod = computed(() => {
  return props.platform.methods.find(
    (m) => m.authorityType === EAuthTypes.TOKEN
  );
});

const url = computed<string | null>(() => {
  return currentMethod.value?.url ?? null;
});

const clearConnection = () => {
  apiIdModel.value = "";
  apiKeyModel.value = "";
};

const apiIdControl = ref<typeof Input | null>(null);
const apiKeyControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    !apiIdModel.value ||
    apiIdControl.value?.hasError ||
    !apiKeyModel.value ||
    apiKeyControl.value?.hasError
  );
});

const hasError = computed<boolean>(() => {
  return hasFormError.value || !isConnectionValid.value;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(
            _unref(ETelematicsMessagesKeys).SWITCHBOARD_USERNAME_TOKEN_INSTRUCTION_TITLE
          )), 1),
      _createVNode(HelpLink, {
        link: _ctx.$t(_unref(HELP_URL_BY_PLATFORM)[_ctx.platform.const])
      }, null, 8, ["link"])
    ]),
    _createVNode(_component_d_input, {
      ref_key: "apiIdControl",
      ref: apiIdControl,
      class: "drv-my-2 drv-form-control-adaptive",
      modelValue: apiIdModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((apiIdModel).value = $event)),
      label: 
        _ctx.$t(_unref(ETelematicsMessagesKeys).SWITCHBOARD_USERNAME_TOKEN_USERNAME_LABEL)
      ,
      disable: isDisabled.value,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "label", "disable", "rules"]),
    _createVNode(_component_d_password_input, {
      ref_key: "apiKeyControl",
      ref: apiKeyControl,
      class: "drv-form-control-adaptive drv-my-2",
      modelValue: apiKeyModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((apiKeyModel).value = $event)),
      label: 
        _ctx.$t(_unref(ETelematicsMessagesKeys).SWITCHBOARD_USERNAME_TOKEN_TOKEN_LABEL)
      ,
      disable: isDisabled.value,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "label", "disable", "rules"]),
    (url.value && currentMethod.value?.check_connection)
      ? (_openBlock(), _createBlock(CheckConnection, {
          key: 0,
          class: "drv-py-2",
          modelValue: isConnectionValid.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isConnectionValid).value = $event)),
          loading: isLoading.value,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((isLoading).value = $event)),
          "is-model-fullfiled": !hasFormError.value,
          "platform-type": _ctx.platform.const,
          url: url.value,
          creds: model.value,
          onClear: clearConnection
        }, null, 8, ["modelValue", "loading", "is-model-fullfiled", "platform-type", "url", "creds"]))
      : _createCommentVNode("", true)
  ]))
}
}

})